import { render, staticRenderFns } from "./topIconContainer.vue?vue&type=template&id=b8bb8302&scoped=true"
import script from "./topIconContainer.vue?vue&type=script&lang=js"
export * from "./topIconContainer.vue?vue&type=script&lang=js"
import style0 from "./topIconContainer.vue?vue&type=style&index=0&id=b8bb8302&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bb8302",
  null
  
)

export default component.exports